// Finish by tier (research §2): T1–3 matte plastic (cel bands only); T4+ painted with a highlight stripe
// along the receiver; rim light from rimMinTier; glow in the body's own hue from glowMinTier (never the
// orange tier-5 ramp colour, so no blaze-hued pixels appear around the body).
import type { Ctx2D } from '../../ctx.ts';
import { fillP } from '../../passes.ts';
import { rrect } from '../../shapes.ts';
import type { GunKit } from './types.ts';

export interface Finish {
  rim: boolean;
  glowTok: string | null;
  stripe: ((c: Ctx2D) => void) | null;
}

export function finish(g: GunKit): Finish {
  const t = g.r.tier;
  const { x, y, w } = g.r.receiver;
  const hi = g.pal.sw(g.r.main).hi;
  return {
    rim: t >= g.pal.rules.rimMinTier,
    glowTok: t >= g.pal.rules.glowMinTier ? g.r.main : null,
    stripe: t >= 4 ? (c) => fillP(c, rrect(x + 5, y + 3.2, w - 12, 2.4, 1.2), hi) : null,
  };
}
